<template>
  <ContentLayout
    :title="$t('label_essweb_site_form_newTitle')"
    widthClass="max-1000"
    :initData="siteData"
    @change="(changed) => (isChanged = changed)"
    backgroundClass="white"
    :checkData="[
      'site_name',
      'site_description',
      'site_abbr',
      'longitude',
      'latitude',
      'address_line_1',
      'city_uuid',
      'country_uuid',
      'address_line_2',
      'address_line_3',
      'effective_utc_datetime',
      'expired_utc_datetime',
      'site_type_uuid',
      'site_code',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row justify="start" class="white lighten-5">
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :bindData="siteData.site_name"
              maxlength="100"
              @change="
                (valueArr) => {
                  siteData.site_name = valueArr;
                }
              "
              :label="$t('label_essweb_site_form_siteNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="3" md="3" lg="3" cols="12">
            <inputTextFiledMultiLang
              :bindData="siteData.site_abbr"
              maxlength="20"
              @change="
                (valueArr) => {
                  siteData.site_abbr = valueArr;
                }
              "
              :label="$t('label_essweb_site_form_siteAbbrLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="3" md="3" lg="3" cols="12">
            <normalInputTextFiled
              :maxlength="100"
              v-model="siteData.site_code"
              :rules="
                $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
              "
              :label="$t('label_essweb_ClaimReason_form_codeLabel')"
            />
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="siteData.site_description"
              maxlength="500"
              @change="
                (valueArr) => {
                  siteData.site_description = valueArr;
                }
              "
              :label="$t('label_essweb_site_form_descriptionLabel')"
            />
          </v-col>
          <!-- 地图显示，暂时废弃 -->
          <!-- <div class="map-container pa-3" id="allmap" ref="allmap" v-show="false">
                <g-map :center="[103.86438,30.68673]">
                  <g-marker
                    v-for="(item,index) in markers"
                    :key="index"
                    :center="item.center"
                    :ext_data="{index,item}"
                  ></g-marker>
                </g-map>
          </div>-->
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              maxlength="20"
              type="number"
              :rules="
                $GetRules(['_Require_Rules', '_Length_Rules'], [null, 20])
              "
              :label="$t('label_essweb_site_form_longtitudeLabel')"
              v-model="siteData.longitude"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              maxlength="20"
              type="number"
              :rules="
                $GetRules(['_Require_Rules', '_Length_Rules'], [null, 20])
              "
              :label="$t('label_essweb_site_form_latitudeLabel')"
              v-model="siteData.latitude"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="siteData.address_line_1"
              maxlength="500"
              @change="
                (valueArr) => {
                  siteData.address_line_1 = valueArr;
                }
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="$t('label_essweb_site_form_addressLine1Label')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              maxlength="500"
              :showLabel="false"
              :bindData="siteData.address_line_2"
              @change="
                (valueArr) => {
                  siteData.address_line_2 = valueArr;
                }
              "
              :label="$t('label_essweb_site_form_addressLine2Label')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              maxlength="500"
              :showLabel="false"
              :bindData="siteData.address_line_3"
              @change="
                (valueArr) => {
                  siteData.address_line_3 = valueArr;
                }
              "
              :label="$t('label_essweb_site_form_addressLine3Label')"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              label="label_essweb_site_form_countryLabel"
              :items="allCountry"
              item-text="name"
              item-value="id"
              v-model="siteData.country_uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              label="label_essweb_site_form_cityLabel"
              :items="allCity"
              item-text="name"
              item-value="id"
              v-model="siteData.city_uuid"
              :disabled="!siteData.country_uuid"
            >
            </AutoComplete>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_site_form_siteTypeLabel"
              :items="siteType"
              item-text="site_type_name"
              item-value="uuid"
              chips
              small-chips
              deletable-chips
              v-model="siteData.site_type_uuid"
              multiple
              :rules="$GetRules(['_Require_ArrRules'], [null])"
            >
              <template v-slot:selection="{ data }">
                {{ data.item.site_type_name }}
              </template>
              <template v-slot:item.title="{ data }">
                {{ data.item.site_type_name }}
              </template>
            </AutoComplete>
          </v-col>

          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              :label="$t('label_essweb_site_form_effectiveDateLabel')"
              type="date"
              :rules="$GetRules(['_Require_ArrRules'], [null])"
              :defaultTime="siteData.effective_utc_datetime"
              :max="siteData.expired_utc_datetime"
              placeholder="YYYY/MM/DD"
              @change="
                (time) => {
                  siteData.effective_utc_datetime = time;
                }
              "
            />
          </v-col>
          <!-- <v-col md="6">
                <v-sheet class=" text--secondary">Time Zone</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              single-line
              dense
              v-model="siteData.effective_time_zone"
              placeholder="start time zone"
              filled
            >
              <template v-slot:no-data> <noContent /> </template>
              </v-select>
          </v-col>-->
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              :label="$t('label_essweb_site_form_expiredDateLabel')"
              type="date"
              :min="siteData.effective_utc_datetime"
              :defaultTime="siteData.expired_utc_datetime"
              placeholder="YYYY/MM/DD"
              @change="
                (time) => {
                  siteData.expired_utc_datetime = time;
                }
              "
            />
          </v-col>
          <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_site_form_timeZoneLabel")
            }}</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              dense
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              v-model="siteData.expired_time_zone"
              single-line
              :placeholder="$t('label_essweb_site_form_timeZoneLabel')"
              filled
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_site_form_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              filled
              counter="500"
              dense
              single-line
              v-model="siteData.remarks"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- content -->
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions newBtn @new="toAddSite" @cancel="$toBack(isChanged)" />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "addSite",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
    siteType() {
      return this.$getSelectTrans(this.siteTypeData, "site_type_name");
    },
    allCountry() {
      return this.$getSelectTrans(this.allCountryData, "name");
    },
  },
  watch: {
    "siteData.country_uuid": function (val) {
      this.getAllCity();
    },
  },
  data() {
    return {
      maps: null,
      tab: null,
      isChanged: false,
      markers: [
        // marker 集合
        {
          center: [103.86438, 30.68673], // 点位置
          icon: "https://assets.xiaokakj.com/static/img/chuzuche/dian.png", // 点图标
        },
      ],
      allCity: [],
      allCountryData: [],
      siteData: {
        site_name: "",
        site_description: "",
        site_abbr: "",
        longitude: "",
        latitude: "",
        site_code: "",
        address_line_1: "",
        city_uuid: "",
        country_uuid: "",
        address_line_2: "",
        address_line_3: "",
        effective_utc_datetime: "",
        expired_utc_datetime: "",
        effective_time_zone: 0,
        expired_time_zone: 0,
        site_type_uuid: [],
        remarks: "",
      },
      siteTypeData: [],
    };
  },
  created() {
    this.siteData.effective_time_zone = this.defaultUTC;
    this.siteData.expired_time_zone = this.defaultUTC;
  },
  mounted() {
    // 初始化
    // this.siteData.site_name = this.$getCommonLangKey(this.companyLang);
    // this.siteData.site_description = this.$getCommonLangKey(this.companyLang);
    // this.siteData.site_abbr = this.$getCommonLangKey(this.companyLang);
    // this.siteData.address_line_1 = this.$getCommonLangKey(this.companyLang);
    // this.siteData.address_line_2 = this.$getCommonLangKey(this.companyLang);
    // this.siteData.address_line_3 = this.$getCommonLangKey(this.companyLang);

    this.initMap();
    this.getSiteType();
    this.getAllCountry();
  },
  methods: {
    removeType: function (item) {
      const index = this.siteData.site_type_uuid.indexOf(item.uuid);
      if (index >= 0) this.siteData.site_type_uuid.splice(index, 1);
    },
    getSiteType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site_type",
        url: "/site-type/get-site-type-list/",
      }).then((res) => {
        that.siteTypeData = res.data;
      });
    },
    getAllCity: function () {
      const that = this;
      that.allCity = [];
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/other/get-position/",
        data: {
          level: 3,
          pid: this.siteData.country_uuid,
        },
      }).then((res) => {
        that.allCity = res.data;
      });
    },
    getAllCountry: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/other/get-position/",
        data: { level: 2 },
      }).then((res) => {
        that.allCountryData = res.data;
      });
    },
    toAddSite: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/add-site-table/",
        data: {
          site_code: this.siteData.site_code,
          site_name: this.$transCommonLangKey(this.siteData.site_name),
          site_description: this.$transCommonLangKey(
            this.siteData.site_description
          ),
          site_abbr: this.$transCommonLangKey(this.siteData.site_abbr),
          longitude: this.siteData.longitude,
          latitude: this.siteData.latitude,
          address_line_1: this.$transCommonLangKey(
            this.siteData.address_line_1
          ),
          address_line_2: this.$transCommonLangKey(
            this.siteData.address_line_2
          ),
          address_line_3: this.$transCommonLangKey(
            this.siteData.address_line_3
          ),
          city_uuid: this.siteData.city_uuid,
          country_uuid: this.siteData.country_uuid,
          effective_utc_datetime: this.$getTimeValue(
            this.siteData.effective_utc_datetime
          ),
          // effective_time_zone: this.siteData.effective_time_zone,
          expired_utc_datetime: this.$getTimeValue(
            this.siteData.expired_utc_datetime
          ),
          // expired_time_zone: this.siteData.expired_time_zone,//BJ
          site_type_uuid: this.siteData.site_type_uuid.join(","),
          remarks: this.siteData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
    initMap: function () {
      // let that = this;
      // // 创建google地图
      // this.maps = new google.maps.Map(document.getElementById("allmap"), {
      //   zoom: 13,
      //   //地图中心点，这里我以第一个数据的经纬度来设置中心点
      //   // center: { lat: mapData[0].latitude, lng: mapData[0].longitude },
      //   disableDefaultUI: false,
      //   zoomControl: false
      // });
    },
  },
};
</script>
<style>
.map-container {
  width: 100%;
  height: 400px;
}
</style>
